<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search v-model="form.user_name" placeholder="请输入搜索关键词" @search="onSearch"></van-search>
			<van-dropdown-menu>
				<van-dropdown-item
					v-model="form.dispatch_status"
					:options="dispatch_status"
					@change="onSearch"
				/>
			</van-dropdown-menu>
		</van-sticky>

		<van-list
			v-model="list.loading"
			:finished="list.finished"
			finished-text="没有更多了"
			@load="onLoad"
			style="padding-bottom: 50px;"
		>
			<van-swipe-cell
				v-for="(item, index) in list.list"
				:key="index"
				:disabled="item.dispatch_status==2 || item.dispatch_status==4"
			>
				<van-cell class="item-list" @click="viewDetails(item.dispatch_status, item.dispatch_id)">
					<div class="user-title">
						<span class="user-title-name" style="font-weight: 600;">
							<van-icon name="todo-list-o" />
							{{item.event_name}}
						</span>
						<span class="user-title-date" style="float: right;">{{item.initiate_date}}</span>
					</div>
					<div style="float: left;">
						<van-icon name="cluster-o" />
						{{item.dispatch_name}} - {{item.node_name}}
					</div>
					<van-tag
						plain
						:type="dispatch_status[item.dispatch_status-1].type"
						style="float: right; margin-top: 5px;"
					>{{dispatch_status[item.dispatch_status-1].text}}</van-tag>
				</van-cell>
				<template #right>
					<div class="swipe-button" v-if="item.assign_status == 0">
						<van-button
							class="swipe-button"
							@click="openCarried(item.assign_id)"
							square
							type="primary"
							text="开启"
						/>
						<!-- <van-button
							class="swipe-button"
							@click="termination(item.assign_id)"
							square
							type="danger"
							text="终止"
						/> -->
						<van-button 
							v-if="item.process_id"
							class="swipe-button"
							@click="application(item.assign_id,item.client_id,item.order_id,item.process_id)"
							square
							type="warning"
							text="报销"
						/>
					</div>
					<div class="swipe-button" v-else>
						<van-button
							v-if="item.assign_status == 1"
							class="swipe-button"
							@click="carryOut(item.assign_id)"
							square
							type="primary"
							text="完成"
						/>
						<!-- <van-button
							class="swipe-button"
							@click="termination(item.assign_id)"
							square
							type="danger"
							text="终止"
						/> -->
						<van-button 
							v-if="item.process_id"
							class="swipe-button"
							@click="application(item.assign_id,item.client_id,item.order_id,item.process_id)"
							square
							type="warning"
							text="报销"
						/>
					</div>
				</template>
			</van-swipe-cell>
		</van-list>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="organization" icon="description" to="/dispatch">我组织的</van-tabbar-item>
			<van-tabbar-item name="initiate" icon="logistics" to="/dispatch/initiate">我发起的</van-tabbar-item>
			<van-tabbar-item name="carriedOut" icon="upgrade" to="/dispatch/carriedOut">我执行的</van-tabbar-item>
			<van-tabbar-item name="add" icon="add-o" to="/dispatch/add">新增派单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Toast } from "vant";
import { post } from "@/api/dispatch";
import { Dialog } from "vant";

export default {
	name: "customer",
	components: {
		navbar
	},
	data() {
		return {
			title: "我执行的",
			activeName: "carriedOut",
			list: {
				list: [],
				loading: false,
				finished: false
			},
			dispatch_status: [
				{ text: "进行中", value: 1, type: "primary" },
				{ text: "意外终止", value: 2, type: "danger" },
				{ text: "待确认完成", value: 3, type: "warning" },
				{ text: "完成", value: 4, type: "success" }
			],
			assign_status: [
				{ text: "未开始", value: 0, type: "default" },
				{ text: "进行中", value: 1, type: "primary" },
				{ text: "意外终止", value: 2, type: "warning" },
				{ text: "已完成", value: 3, type: "success" }
			],
			form: {
				requestType: "event_execute_list_data",
				page: 1,
				limit: 10,
				dispatch_status: 1,
				user_name: ""
			},
			isFirstEnter: true
		};
	},
	activated() {
		console.log(this.$route.params.refresh);
		if (this.$route.params.refresh != true) {
			this.list.list = [];
			this.activeName = "carriedOut";
			this.list.finished = false;
			this.form.page = 1;
			this.form.dispatch_status = 1;
			this.list.user_name = "";
			this.onLoad();
		}
	},
	methods: {
		activated() {
			if (!this.$route.meta.isBack || this.isFirstEnter) {
				this.onLoad();
			}
			this.$route.meta.isBack = false;
			this.isFirstEnter = false;
		},
		onSearch() {
			this.form.page = 1;
			this.onLoad();
		},
		onLoad() {
			post(this.form)
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.list.finished = true;
					}
					if (this.form.page != 1) {
						this.list.list = this.list.list.concat(res.obj.rows);
					} else {
						this.list.list = res.obj.rows;
					}

					this.form.page += 1;
					this.list.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.list.loading = false;
					this.list.finished = true;
					return Toast.fail("数据异常");
				});
		},
		viewDetails(type, id) {
			this.$router.push({
				path: "/dispatch/details",
				query: { type: type, id: id, p: false }
			});
		},
		termination(id) {
			Dialog.confirm({
				title: "终止派单"
			})
				.then(() => {
					post({
						requestType: "open_event",
						assign_id: id,
						assign_status: 2
					})
						.then(() => {
							this.form.page = 1;
							this.onLoad();
							return Toast.success("终止派单成功");
						})
						.catch(err => {
							console.log(err);
							return Toast.fail("数据异常");
						});
				})
				.catch(() => { });
		},
		carryOut(id) {
			this.$router.push({
				path: "/dispatch/details_carryout",
				query: { id: id }
			});
		},
		application(id,client_id,order_id,process_id) {
			this.$router.push({
				path: "/dispatch/details_application",
				query: { id: id,client_id:client_id,order_id:order_id,process_id:process_id }
			});
		},
		openCarried(id) {
			Dialog.confirm({
				title: "开启派单"
			})
				.then(() => {
					post({
						requestType: "open_event",
						assign_id: id,
						assign_status: 1
					})
						.then(() => {
							this.form.page = 1;
							this.onLoad();
							return Toast.success("开启派单成功");
						})
						.catch(err => {
							console.log(err);
							return Toast.fail("数据异常");
						});
				})
				.catch(() => { });
		}
	}
};
</script>

<style lang="scss" scoped>
.swipe-button {
	height: 100%;
}
</style>
